import Route, { RouteStop } from "@mapmycustomers/shared/types/entity/Route";

// The stops a rep still has to visit. Checked-off stops are excluded from every route
// preview except the all-stops completion mode — a half-executed route must preview as the
// remaining drive, not the original plan — so this is also what the empty-preview guards
// count: the BE rejects an empty stopTime[] (v0280).
const getRemainingRouteStops = (route: Pick<Route, "stopTime">): RouteStop[] =>
  (route.stopTime ?? []).filter((stop) => !stop.checkedOff);

export default getRemainingRouteStops;
